import React from 'react';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import CardMovementsList from './CardMovementsList/CardMovementsList';

const CardMovementsView = () => {
  return (
    <>
      <RolePrivateRoute component={CardMovementsList} />
    </>
  );
};


export default CardMovementsView;
